var particleUpdaterEndPS = `
		writeOutput();
}
`;

export { particleUpdaterEndPS as default };
